// extracted by mini-css-extract-plugin
export var dropdownIcon = "_nv-6";
export var imgContainer = "_nv-3";
export var menuIcon = "_nv-5";
export var pillWrapper = "_nv-2";
export var pillsContainer = "_nv-1";
export var subscriptionCard = "_nv-0";
export var subscriptionLogo = "_nv-4";